import { AVAILABLE_VIDEO_TYPES } from '@wix/wix-vod-shared/widget';
import { DEFAULT_TRANSLATIONS as VIDEO_PLAY_TRANSLATIONS } from '../play-button-text';

export const DEFAULT_TRANSLATIONS = {
  ...VIDEO_PLAY_TRANSLATIONS,
  [AVAILABLE_VIDEO_TYPES.FULL]: 'widget.overlay-buttons.start-watching',
};
